import { Drawer } from "@blueprintjs/core";
import { type ItemCreateDrawerProps } from "@package/ui-apollo-components";
import { PostEdit } from "./PostEdit";

export function PostCreateDrawer({
  isOpen,
  onCreated,
  onClose,
}: ItemCreateDrawerProps) {
  return (
    <Drawer isOpen={isOpen} className="bg-slate-100 overflow-auto px-4 pb-4">
      <PostEdit
        toolbarProps={{
          onCanceled: onClose,
          onDeleted: () => {},
          onCreated: (id) => {
            onCreated(id);
            onClose();
          },
        }}
      />
    </Drawer>
  );
}
